<template>
  <el-dialog title="发送优惠券" :visible.sync="visible" width="500px" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="用户昵称">
        <el-input v-model="user.nickname" disabled />
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="user.phone" disabled />
      </el-form-item>
      <el-form-item label="优惠券ID" prop="coupon_id">
        <el-input-number
          v-model="form.coupon_id"
          placeholder="请输入优惠券ID"
          controls-position="right"
          style="width: 100%"
        />
        <span style="margin-left: 10px; color: #909399;">请输入要发放的优惠券ID</span>
      </el-form-item>
      <el-form-item label="发放数量" prop="quantity">
        <el-input-number
          v-model="form.quantity"
          :min="1"
          :max="100"
          controls-position="right"
          style="width: 100%"
        />
        <span style="margin-left: 10px; color: #909399;">最多发放100张</span>
      </el-form-item>
      <el-alert
        title="提示"
        type="info"
        :closable="false"
        style="margin-top: 10px;"
      >
        发放的优惠券有效期为30天，从发放时间开始计算。
      </el-alert>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { sendCoupon } from '@/api/user'

export default {
  name: 'SendCouponDialog',
  data() {
    return {
      visible: false,
      submitting: false,
      user: {},
      form: {
        user_id: 0,
        coupon_id: null,
        quantity: 1
      },
      rules: {
        coupon_id: [
          { required: true, message: '请输入优惠券ID', trigger: 'blur' },
          { type: 'number', min: 1, message: '优惠券ID必须大于0', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '请输入发放数量', trigger: 'blur' },
          { type: 'number', min: 1, max: 100, message: '发放数量为1-100张', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(user) {
      this.user = { ...user }
      this.form.user_id = user.id
      this.form.coupon_id = null
      this.form.quantity = 1
      this.visible = true
    },
    handleSubmit() {
      console.log('form', this.form)
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submitting = true
          try {
            console.log('form2:', this.form)
            const res = await sendCoupon(this.form)
            if (res.code === 200) {
              this.$message.success(`成功发放${this.form.quantity}张优惠券`)
              this.visible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.msg || '发送失败')
            }
          } catch (error) {
            this.$message.error(error.message || '发送失败')
          } finally {
            this.submitting = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
:deep(.el-input-number) {
  width: 100%;
}
</style>
